var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeychlessFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_8871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -3,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_8871)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 20.9966L12.151 -5H28.302L-4 20.9966Z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 20.9964L30.4632 7.99809V-8.10352L-4 20.9964Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 20.9964L30.4632 15.9981V7.89648L-4 20.9964Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 20.9964H30.4632V13.8965L-4 20.9964Z",
    fill: "#5EAA22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeychlessFlagIcon);
export default __webpack_public_path__ + "static/media/SeychlessFlagIcon.308f8c100d12d2881d072f7cdd557624.svg";
export { ForwardRef as ReactComponent };